import { AxiosInstance } from "axios";

export interface GetAppVersionResponseI {
  version: string;
}

export const VersionControlAPIEndpoints = (api: AxiosInstance) => ({
  getAppVersion: () =>
    api.get<GetAppVersionResponseI>(`/public/v1/frontend_version`),
});
